import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ProjectCommunicationService } from '../../communication/project-comms.service';
import { take, takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { UserpilotReloader } from '../../helper/userpilot-reloader.component';
import { PlatformPickerDialogComponent } from './platform-picker-dialog/platform-picker-dialog.component';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent extends UserpilotReloader implements OnInit, OnDestroy {
 onDestroyNotifier = new Subject<boolean>();
  projectLoaded = false;
  isCustomLogo = false;

  constructor(
    private dialog: MatDialog,
    private projectCommService: ProjectCommunicationService,
    private http: HttpClient
  ) {
    super();
  }

  ngOnInit() {
    this.projectCommService.projectFullyLoadedNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(loaded => {
        this.projectLoaded = loaded;
    });

    this.http.get<{isCustomLogo: boolean}>(`/dbapi/logo/isCustomLogo?product=ADA&accountid=${this.getAccountID()}`)
      .pipe(take(1))
      .subscribe(res => {
        this.isCustomLogo = res['isCustomLogo'];
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.next(true);
    this.onDestroyNotifier.unsubscribe();
  }

  /**
   * Returns a string that is divided up at spaced to fit the provided length.
   * @param maxLength is a number for the max length of the name.
   * @param projectTitle is the projects title.
   */
  truncateAfterWord(maxLength: number, projectTitle: string) {
    if (projectTitle.length <= maxLength) {
      return projectTitle;
    } else {
      return projectTitle.slice(0, projectTitle.lastIndexOf(' ', maxLength)) + '...';
    }
  }

  /**
   * Get the project title formatted for the topbar. If the truncate parameter is provided the title will be truncated.
   * @param truncate is a boolean for if the title will be truncated.
   */
  getProjectTitle(truncate?: boolean) {
    const truncateLength = 40;
    if (this.projectLoaded) {
      const projectInfo = this.projectCommService.getProjectInfo();
      if (projectInfo && projectInfo.title) {
        const plantName = projectInfo.title;
        if (truncate) {
          return this.truncateAfterWord(truncateLength, plantName);
        } else {
          return plantName;
        }
      }
    }
  }

  /**
   * reads the account id from the local storage and appends it to the logo request in HTML
   * Custom headers are loaded using this info
   */
  getAccountID() {
    return localStorage.getItem('accountID');
  }

  openPlatformPicker() {
    this.dialog.open(PlatformPickerDialogComponent, {
      backdropClass: "platform-picker-backdrop",
      id: "platform-picker-dialog",
      position: {
        top: '4px'
      }
    });
  }
}
